// ignore-string-externalization

import React from 'react';
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { Blog } from '../../features/Blog';
import {
  fetchBlogData,
  fetchHeros,
  BlogDataProvider,
} from '../../features/Blog/useBlogData';
import { getLanguage } from '../../utils/getLanguage';

export const getStaticProps: GetStaticProps = async ctx => {
  const smartlingLanguage = getLanguage(ctx.locale!) || 'en-US';

  const [blogData, heroData] = await Promise.all([
    fetchBlogData({ smartlingLanguage }),
    fetchHeros(),
  ]);

  return {
    props: JSON.parse(JSON.stringify({ blogData, heroData })),
    revalidate: 60,
  };
};

const BlogPage = ({
  blogData,
  heroData,
}: InferGetStaticPropsType<typeof getStaticProps>) => (
  <BlogDataProvider initialData={blogData} heroData={heroData}>
    <Blog />
  </BlogDataProvider>
);

export default BlogPage;
